import React, { useCallback, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { AppContext } from '@prisjakt/ui-app-context';
import Modal from '../../../../components/modal';

import * as S from './styles';

import { hideShopReviewThankYouDialog } from '../../actions';

import { AppState } from '../../../../reducers';
import ShopReviewThankYou from './shop-review-thank-you';

type Props = {
  uid: string;
};

const selectOpenId = (state: AppState) =>
  state.areas.review.thankYouDialog.openId;

const ThankYouModal = ({ uid }: Props) => {
  const { t, market } = useContext(AppContext);
  const dispatch = useDispatch();
  const openId = useSelector(selectOpenId);

  const handleClose = useCallback(() => {
    dispatch(hideShopReviewThankYouDialog());
  }, []);

  return market.shopOfTheYear ? (
    <Modal isOpen={openId === uid} onRequestClose={handleClose} width={600}>
      <S.Content>
        <ShopReviewThankYou />
        <S.CloseButton size="small" color="primary" onClick={handleClose}>
          {t('symbols', 'symbol.close')}
        </S.CloseButton>
      </S.Content>
    </Modal>
  ) : null;
};

export default ThankYouModal;
